// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commission .el-table th,.commission .el-table tr{background:#f1f1f1}", ""]);
// Exports
module.exports = exports;
